@if (logement$ | async; as logement) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">Contacts
        @if (logement?.isOpen()) {
          <button class="btn btn-blue btn-lg float-end" routerLink="creer">
            <fa-icon [icon]="faPlus"></fa-icon> Ajouter
          </button>
        }
      </h2>
    </div>
    <div class="m-2 p-4 bg-white rounded">
      @if (contacts$ | async; as contacts) {
        @if (contacts.length > 0) {
          <div class="row">
            @for (contact of contacts; track contact) {
              <div class="col-sm-6 col-lg-4 col-xl-3 mb-4">
                <app-contact-card
                  [photo]="contact.photo ? (contact.photo | backResource) : ''"
                  [name]="contact.nom"
                  [job]="contact.metier"
                  [phone]="contact.numeroTelephone"
                  [email]="contact.email"
                  [site]="contact.site"
                  >
                  @if (logement?.isOpen()) {
                    @if (contactService.canUpdate(contact,logement)) {
                      <a ngbDropdownItem [routerLink]="'modifier/' + contact.id">Modifier</a>
                      <app-delete-confirm (deleted)="delete(contact)" [message]="'Confirmez-vous la suppression de ce contact ?'">
                        <button ngbDropdownItem>Supprimer</button>
                      </app-delete-confirm>
                    }
                    @if ((logement.userPermissions.updatable && contact.ajouteParParticulier) || (contactService.coproCanOpenToLocataires(userService.data, contact, logement) && !userService.isLocataire(logement)) ) {
                      @if (!contact.roles.includes('ROLE_LOCATAIRE')) {
                        <app-open-locataire-confirm (deleted)="openToLocataires(contact)">
                          <button ngbDropdownItem>Ouvrir au(x) locataire(s)</button>
                        </app-open-locataire-confirm>
                      }
                      @if (contact.roles.includes('ROLE_LOCATAIRE')) {
                        <app-open-locataire-confirm (deleted)="closeToLocataires(contact)" [message]="'Confirmez-vous la fermeture de ce contact au(x) locataire(s) ?'" [title]="'Confirmation de fermeture'">
                          <button ngbDropdownItem>Fermer au(x) locataire(s)</button>
                        </app-open-locataire-confirm>
                      }
                    }
                  }
                </app-contact-card>
              </div>
            }
          </div>
        } @else {
          <div class="alert alert-info">Renseignez ici tous les contacts utiles de votre logement (plombier, gardien, voisin, …)
            <br>
              <button class="btn btn-lg btn-orange" routerLink="creer">
                Ajouter un contact
              </button>
            </div>
          }
        }
      </div>
    </section>
  }
